import React from 'react';
import UserLayout from '../components/UserLayout';
import GeneralSettings from '../components/GeneralSettings';

const GeneralSettingsPage = () => {
  return (
    <UserLayout>
      <GeneralSettings />
    </UserLayout>
  );
};

export default GeneralSettingsPage;
